// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"bb493569","175":"b1ac9b4a","188":"d2ee8612","242":"73c423fc","670":"7b6d844a","796":"f55c00e0","874":"b70cf824","904":"b4a480ca","989":"4cda8c51"}[chunkId] + ".chunk.js";
};